import { Injectable, inject } from '@angular/core';

import { IServiceLevelUpdates } from '@lenderhub/models';
import { LenderHubDataService } from '@shared/services/lenderhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class LenderServiceLevelUpdatesService {
  private readonly lenderHubDataService = inject(LenderHubDataService);

  public getServiceLevelUpdates() {
    return this.lenderHubDataService.get<IServiceLevelUpdates>('LenderServiceLevelUpdates');
  }

  public updateServiceLevelUpdates(model: IServiceLevelUpdates) {
    return this.lenderHubDataService.put('LenderServiceLevelUpdates', model);
  }
}
